import { HeroEditorial } from '@cbhq/cdx-components';
import { mapEntryLink } from '../../globals/navlink.js';
import { getEntryProps } from '../../utils/getEntryProps.js';
import { jsx } from 'react/jsx-runtime';
function EditorialHero({
  title,
  subheadRichText,
  image,
  readTime,
  datePublished,
  tags,
  authors,
  imageFit,
  showSocialSharingLinks
}) {
  const authorsName = authors?.map(author => {
    const props = getEntryProps(author);
    return props.authorName;
  }).join(', ');
  const categoryTag = tags?.find(tag => tag.fields.type !== 'internal');
  const _getEntryProps = getEntryProps(categoryTag),
    label = _getEntryProps.label,
    link = _getEntryProps.link;
  const tagLink = mapEntryLink(link);
  return /*#__PURE__*/jsx(HeroEditorial, {
    headline: title,
    subhead: subheadRichText,
    mediaUrl: image?.fields.file?.url,
    mediaAlt: image?.fields.title,
    author: authorsName,
    datePublished: datePublished,
    categoryTagLabel: label,
    categoryTagUrl: tagLink.url && `/${tagLink.url}`,
    readTime: readTime,
    imageFit: imageFit,
    bordered: true,
    showSocialSharingLinks: showSocialSharingLinks
  });
}
export { EditorialHero };
//# sourceMappingURL=EditorialHero.js.map
